import { Selectors, SelectorWithVersion } from "./types";
import { apiCampaginUrl } from "../utils/config";

export async function retrieveRawData({
  country,
  website,
  vertical,
  force = false,
}: {
  country: string;
  website: string;
  vertical: string;
  force?: boolean;
}): Promise<{ data: any[]; type: "JSON" | "HTML" }> {
  if (!force) {
    const cachedData = localStorage.getItem(
      `${vertical}-${website}-${country}-raw-data`,
    );
    if (cachedData) {
      return JSON.parse(cachedData);
    }
  }

  const response = await fetch(
    `${apiCampaginUrl}/rawDetails?website=${website}&vertical=${vertical}&country=${country}`,
  );
  const examples = await response.json(); //.map(JSON.parse);

  const type = typeof examples[0] === "object" ? "JSON" : "HTML";

  const size = getByteSize(JSON.stringify(examples));

  const sizeLimit = 1 * 1024 * 1024; // 1MB

  const countMax = Math.ceil((10 * sizeLimit) / size);

  localStorage.setItem(
    `${vertical}-${website}-${country}-raw-data`,
    JSON.stringify({
      data: examples.slice(0, countMax),
      type,
    }),
  );

  return {
    data: examples,
    type,
  };
}

export async function retrieveSelectors({
  website,
  vertical,
  force = false,
}: {
  website: string;
  vertical: string;
  force?: boolean;
}): Promise<SelectorWithVersion[]> {
  if (!force) {
    const cachedData = localStorage.getItem(`${vertical}-${website}-selectors`);
    if (cachedData) {
      return JSON.parse(cachedData);
    }
  }

  const response = await fetch(
    `${apiCampaginUrl}/selector/${vertical}/${website}`,
  );
  const selectors = await response.json();

  localStorage.setItem(
    `${vertical}-${website}-selectors`,
    JSON.stringify(selectors),
  );

  return selectors;
}

export async function retrieveParsedData({
  selectors,
  rawData,
  type,
}: {
  selectors: Selectors;
  rawData: any;
  type: "JSON" | "HTML";
}): Promise<{
  results: any;
  errors: any;
}> {
  const body: any = {
    selectors,
  };

  if (type === "JSON") {
    body["json"] = rawData;
  } else {
    body["html"] = rawData;
  }

  console.log("rawData", rawData);

  const response = await fetch(`${apiCampaginUrl}/testParser`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const parsedData = await response.json();
  return parsedData;
}

export async function saveSelectors({
  website,
  vertical,
  selectors,
  user,
}: {
  website: string;
  vertical: string;
  selectors: SelectorWithVersion[];
  user: string;
}) {
  localStorage.setItem(
    `${vertical}-${website}-selectors`,
    JSON.stringify(selectors),
  );
  const response = await fetch(`${apiCampaginUrl}/selector`, {
    method: "POST",
    body: JSON.stringify({
      website,
      vertical,
      selectors,
      user,
    }),
  });
  return response.json();
}

export async function retrieveRawDataById({
  vertical,
  country,
  website,
  id,
  force = false,
}: {
  vertical: string;
  country: string;
  website: string;
  id: string;
  force?: boolean;
}): Promise<any> {
  if (!force) {
    const cachedData = localStorage.getItem(
      `${vertical}-${website}-${country}-${id}-raw-data`,
    );
    if (cachedData) {
      return JSON.parse(cachedData);
    }
  }

  const response = await fetch(
    `${apiCampaginUrl}/rawDetailById/${vertical}/${country}/${website}/${id}`,
  );
  const data = await response.json();

  localStorage.setItem(
    `${vertical}-${website}-${country}-${id}-raw-data`,
    JSON.stringify(data),
  );

  return data;
}

function getByteSize(str: string) {
  const encoder = new TextEncoder();
  const encoded = encoder.encode(str);
  return encoded.length;
}
